module.exports = __webpack_public_path__ + "static/media/pg-contas.f3aa813a.png";